import { SvgIcon, Typography } from "@mui/material";
import WarningIcon from "@static/icons/Warning.svg";
import { cls } from "itsf-ui-common";
import { useStyle } from "./style";

interface IParams {
    message: string;
    id?: string;
    isCardError?: boolean;
}

export const ErrorHelperText = (props: IParams) => {
    const { message, id, isCardError = false } = props;
    const { classes } = useStyle();

    return (
        <div className={cls(classes.errorContainer, isCardError ? classes.cardError : undefined)} id={id}>
            <SvgIcon className={classes.warningIcon} component={WarningIcon} />
            <Typography color="error" variant="small">
                {message}
            </Typography>
        </div>
    );
};
